import { updateInvoice as apiUpdateInvoice } from 'skybolt-api';
import { withDefaultTz } from 'utils/timezone';

// skybolt-api's updateInvoice re-stamps every line item's times onto its date
// and recomputes hours using the browser's timezone. Run it with moment's
// default timezone held at the agency's so those land in agency time.
export default function updateInvoice(args, timezone) {
  return withDefaultTz(timezone, () => apiUpdateInvoice(args));
}
